import { useEffect, useState, useRef } from "react";
import ReactDOM from "react-dom";

export const DropdownPortal = ({
  targetRef,
  children,
  visible,
  onClose,
}: {
  targetRef: React.RefObject<HTMLElement>;
  children: React.ReactNode;
  visible: boolean;
  onClose: () => void; // ← new prop to handle outside click
}) => {
  const [position, setPosition] = useState({ top: 0, left: 0, width: 0 });
  const dropdownRef = useRef<HTMLDivElement>(null); // ← for dropdown DOM

  useEffect(() => {
    if (targetRef.current && visible) {
      const rect = targetRef.current.getBoundingClientRect();
      setPosition({
        top: rect.bottom + window.scrollY,
        left: rect.left + window.scrollX,
        width: rect.width,
      });
    }
  }, [targetRef, visible]);

  // Close dropdown on outside click
  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      const dropdownEl = dropdownRef.current;
      const targetEl = targetRef.current;

      if (
        visible &&
        dropdownEl &&
        !dropdownEl.contains(event.target as Node) &&
        targetEl &&
        !targetEl.contains(event.target as Node)
      ) {
        onClose(); // call the onClose handler
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [visible, targetRef, onClose]);

  if (!visible || !targetRef.current) return null;

  return ReactDOM.createPortal(
    <div
      ref={dropdownRef}
      className="dropdown-menu show customDropAppointment"
      style={{
        position: "absolute",
        top: position.top,
        left: position.left,
        minWidth: position.width,
        zIndex: 9999,
      }}
    >
      {children}
    </div>,
    document.body
  );
};
